<div id="cookieNotice" class="light display-right position-relative" style="display: none;">
    <div id="closeIcon" (click)="closeCookiePopup()">
        <mat-icon>close</mat-icon>
    </div>
    <div class="title-wrap">
        <h4>{{'cookiePopup.cookieConsent' | translate}}</h4>
    </div>
    <div class="content-wrap">
        <div class="msg-wrap">
            <p>{{'cookiePopup.message' | translate}}  <a style="color:#115cfa;" [routerLink]="['/' + lang + '/cookie-policy']">{{'cookiePopup.cookiePolicy' | translate}}</a></p>
            <div class="btn-wrap">
                <button class="btn-primary" (click)="acceptCookieConsent()">{{'cookiePopup.accept' | translate}}</button>
            </div>
        </div>
    </div>
</div>